// A ticking "now" so relative-time labels ("Updated 2 minutes ago") stay
// fresh without a data refetch. Re-renders the consuming component every
// `intervalMs` (default 30s) by bumping an epoch-ms state value.
//
// Kept separate from `relativeTime.ts` so that module stays pure (no
// React import) and unit-testable without a renderer.

import { useEffect, useState } from "react";

/** Returns the current epoch-ms, re-rendering every `intervalMs`. */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState<number>(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
